exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".top-bottom-fixed[data-v-c94a5f98]{width:70%;height:58vh;max-height:80vh}.top-bottom-fixed .divider[data-v-c94a5f98]:first-child{margin-bottom:1px}.centralized-content[data-v-c94a5f98]{display:flex;justify-content:center;align-items:center}@media only screen and (max-width:600px){.top-bottom-fixed[data-v-c94a5f98]{width:95%!important}.top-bottom-fixed .modal-content[data-v-c94a5f98]{height:calc(100% - 97px)!important;padding:1rem}.top-bottom-fixed .modal-footer[data-v-c94a5f98]{padding:1rem}.modal[data-v-c94a5f98]{top:auto;width:95%!important;max-height:86%!important}.text-title[data-v-c94a5f98]{font-size:medium!important}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c94a5f98","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/shared/dialog/ConfirmDialog.vue
// module id = 277
// module chunks = 130